import React, { useRef, useState, useEffect } from "react";

import {
  Root,
  TitleContainer,
  Subtitle,
  Title,
  Container,
  CardsContainer,
  Card,
  CardTitle,
  Action,
} from "./Bbq.style";

import useIntersection from "../../hooks/useIntersection";
import RecipesModal from "../RecipesModal/RecipesModal";

import { slides } from "./config";

export function Bbq({ id, onIntersected }) {
  const ref = useRef(null);
  const isIntersected = useIntersection(ref);
  const [slide, setSlide] = useState(false);

  useEffect(() => {
    if (isIntersected) {
      onIntersected();
    }
  }, [isIntersected, onIntersected]);

  return (
    <Root ref={ref} id={id}>
      <TitleContainer>
        <Title>bbq recipes</Title>
        {/* <Subtitle>with big green egg</Subtitle> */}
      </TitleContainer>

      <Container>
        <CardsContainer>
          {slides.map((slide, idx) => (
            <Card
              key={slide.id}
              role="button"
              tabindex="0"
              style={{ backgroundImage: `url(${slide.imageSrc})` }}
              onClick={() => setSlide(idx)}
            >
              <CardTitle>{slide.label}</CardTitle>
              <Action>See Recipe</Action>
            </Card>
          ))}
        </CardsContainer>
      </Container>

      {slide !== false && (
        <RecipesModal
          slides={slides}
          initialSlide={slide}
          onClose={() => setSlide(false)}
        />
      )}
    </Root>
  );
}
